/** Top inset so spotlight holes do not bleed into the app header. */
export function getTourViewportTopInset(): number {
  const header = document.querySelector<HTMLElement>(".header_container");
  if (header) {
    const rect = header.getBoundingClientRect();
    if (rect.height > 0) return Math.ceil(rect.bottom + 4);
  }
  return 60;
}

export type TourViewportInsets = {
  top: number;
  right: number;
  bottom: number;
  left: number;
};

/** Insets for clamping spotlight holes — keep tight so highlights match targets. */
export function getTourViewportInsets(): TourViewportInsets {
  return {
    top: getTourViewportTopInset(),
    right: 16,
    bottom: 16,
    left: 0,
  };
}

/** Measured sidebar width for placing the guide card beside nav targets. */
export function getTourSidebarWidth(): number {
  const sidebar = document.querySelector<HTMLElement>(".mainLayout_sidebar");
  if (sidebar) {
    const rect = sidebar.getBoundingClientRect();
    if (rect.width > 0) return Math.ceil(rect.width);
  }
  return 220;
}

export function clampTourRectToViewport(
  rect: { top: number; left: number; width: number; height: number },
  insets: TourViewportInsets = getTourViewportInsets(),
): { top: number; left: number; width: number; height: number } {
  const viewportW = window.innerWidth;
  const viewportH = window.innerHeight;
  const maxBottom = viewportH - insets.bottom;
  const minTop = insets.top;

  let top = rect.top;
  let height = rect.height;

  if (top < minTop) {
    height -= minTop - top;
    top = minTop;
  }
  if (top + height > maxBottom) {
    height = Math.max(0, maxBottom - top);
  }

  let left = rect.left;
  let width = rect.width;
  if (left < insets.left) {
    width -= insets.left - left;
    left = insets.left;
  }
  if (left + width > viewportW - insets.right) {
    width = Math.max(0, viewportW - insets.right - left);
  }

  return { top, left, width: Math.max(0, width), height: Math.max(0, height) };
}
